export const shoulderPassiveExtrotText = {
  values: [
    { value: 'ShoulderPassiveExtrot', text: 'Ja', score: 1 },
    { value: 'ShoulderPassiveExtrot', text: 'Nei', score: 0 },
    {
      value: 'ShoulderPassiveExtrot',
      text: 'Ikke aktuelt',
      score: -1,
    },
  ],
};
